import React, {Component} from 'react';
import Container from 'react-bootstrap/Container';

import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { LinkContainer } from "react-router-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GraficResultatsCandidatura from './elementsResultats/GraficResultatsCandidatura';
import GraficParticipacio from './elementsResultats/GraficParticipacio';
import BarraEscrutat from './elementsResultats/BarraEscrutat';
import ReactGA from 'react-ga'
import TaulaGeneral from './elementsResultats/TaulaGeneral';
import TaulaCandidatures from './elementsResultats/TaulaCandidatures';
import Batalla from './elementsResultats/Batalla';
import MetaTags from 'react-meta-tags';
import Publicitat from './estructura/Publicitat'
import Alert from 'react-bootstrap/Alert'
import Compartir from './estructura/Compartir';


class Catalunya extends Component {
  state = {
    resultats:null,
    pantalla: 1
}

trobaResultats() {
    this.props.resultats.forEach(element => {
        if (element.dadesElement.codi == 99) this.setState({resultats:element}) //99 és el codi de Catalunya
    });
}



 componentDidUpdate(prevProps) { //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
    if (this.props.resultats!==prevProps.resultats) {
        this.trobaResultats();
    }
  }

  componentDidMount(){ //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
        ReactGA.pageview(window.location.pathname) //Afegir a cada pàgina que cal comptar
        this.trobaResultats();

  }


render() {   
    
    if (this.state.resultats&&this.state.pantalla!==2) {
        this.setState({pantalla:2})

        var textCompartir;

        if (this.state.resultats.dadesElectorals.censEscrutat_per>0) {
            textCompartir = "Catalunya (" + this.state.resultats.dadesElectorals.censEscrutat_per.toString().replace(/\./g, ',') + "% escrutat): ";

            this.state.resultats.resultatsCandidatures.map((resultat, index) => {
                if (index<5) textCompartir += resultat.sigles.replace(/\s/g, "") + " " + resultat.vots.toLocaleString('en').replace(/\,/g, '.') + " (" + resultat.vots_per.toString().replace(/\./g, ',') + "%) - "
            })

            textCompartir += "Eleccions al Parlament 2021"

            this.setState({textCompartir})
        }
    }
    
    return (
        this.state.pantalla===2 && //Només render quan s'han assignat les dades

        <div className="comarca">

                <MetaTags>
                    <title>Catalunya - Resultats eleccions al parlament de Catalunya 2021 a la comarca del Berguedà - Aquí Berguedà</title>
                    <meta name="description" content={"Consulta tots els resultats de Catalunya a les eleccions al Parlament de Catalunya 2021"} />
                    <meta property="og:title" content={"Resultats eleccions al Parlament de Catalunya 2021"} />
                </MetaTags> 

          <Container>

            <h5>Resultats provisionals</h5>
            <h2>Catalunya</h2>

            {this.state.resultats &&
            <div>
                {this.state.resultats.dadesElectorals.censEscrutat_per!==0 &&
                    <div>
            
                    <Row className="dadesGenerals">
                        <Col sm={8}>
                            <p className="escrutat"><BarraEscrutat escrutat={this.state.resultats.dadesElectorals.censEscrutat_per}/></p>
                            {/* Taula Dades generals */}
                            <TaulaGeneral dades={this.state.resultats.dadesElectorals}/>
                        </Col>
                        <Col sm={4}><GraficParticipacio participacio={this.state.resultats.dadesElectorals.totalVotants_per} abstencio={this.state.resultats.dadesElectorals.abstencio_per}/></Col>
                    </Row>

                    <Row><Col><Publicitat/></Col></Row>
                
                    <Row className="dadesCandidatures">
                        {/* Taula Candidatures */}
                        <Col sm={8}>
                            <TaulaCandidatures partits={this.props.partits} resultats={this.state.resultats.resultatsCandidatures}/>
                        </Col>
                        <Col sm={4}>
                            <GraficResultatsCandidatura resultats={this.state.resultats.resultatsCandidatures} partits={this.props.partits}/>
                        </Col>
                    </Row>

                    <Compartir url={this.props.match.url} text={this.state.textCompartir}/>

                    <Breadcrumb>
                        <LinkContainer to="/resultats/"><Breadcrumb.Item>Resultats poble a poble</Breadcrumb.Item></LinkContainer>
                    </Breadcrumb>

                    {this.props.match.params.opcions&&this.props.match.params.opcions==="batalla" && <Batalla resultatsCandidatures={this.state.resultats.resultatsCandidatures}/>}

                    </div>}
            
                {this.state.resultats.dadesElectorals.censEscrutat_per===0 &&
                    <div>
                        <Alert variant='danger'>
                            Encara no hi ha dades per mostrar. 0% escrutat.
                        </Alert>  
                    </div>}

           </div>}
           </Container>
        </div>
    )
    
}

}

export default Catalunya; 